import ProduttivoMuiThemeV2 from '@/components/shared/themes/ProduttivoThemeV2'

const primaryColor = ProduttivoMuiThemeV2.palette.primary.main

export const palette = Array.from({ length: 100 }, (_, i) => ({
  color: i === 0 ? primaryColor : `hsl(${(135 + i * 137.508) % 360}, 70%, 45%)`,
  textColor: '#fff',
}))
